import { IconChevron, IconCode, IconSdk } from "../components/icons";

export function SdkHubPage({ go }: { go: (to: string) => void }) {
  return (
    <div className="mobile-page">
      <p className="mobile-page-lead">Download and integrate the same live camera, GPS, and PTT APIs used by this app.</p>
      <div className="settings-group">
        <button type="button" className="settings-row" onClick={() => go("/developer/web-sdk")}>
          <span className="settings-row-icon">
            <IconCode />
          </span>
          <span className="settings-row-copy">
            <strong>Web SDK</strong>
            <em>@dashcam/camera-sdk for browsers and Node</em>
          </span>
          <IconChevron className="settings-row-chevron" />
        </button>
        <button type="button" className="settings-row" onClick={() => go("/developer/flutter-sdk")}>
          <span className="settings-row-icon">
            <IconSdk />
          </span>
          <span className="settings-row-copy">
            <strong>Flutter SDK</strong>
            <em>dashcam_camera_sdk for iOS and Android</em>
          </span>
          <IconChevron className="settings-row-chevron" />
        </button>
      </div>
    </div>
  );
}
